var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 1.5H8.4375V6.5H14.0625V14.5H3.9375V1.5ZM10.125 2.12188L13.3629 5H10.125V2.12188ZM10.125 0H2.25V16H15.75V5L10.125 0ZM11.4785 10C11.4785 8.50625 10.118 7.29688 8.4375 7.29688C6.75703 7.29688 5.39648 8.50625 5.39648 10C5.39648 11.4937 6.75703 12.7031 8.4375 12.7031C8.97188 12.7031 9.47109 12.5812 9.90703 12.3687C10.6629 13.0437 11.2043 13.525 11.5277 13.8156L12.723 12.7563C12.3996 12.4656 11.8582 11.9844 11.0988 11.3062C11.3414 10.9187 11.4785 10.4719 11.4785 10ZM8.4375 8.6875C8.82911 8.6875 9.20468 8.82578 9.48159 9.07192C9.7585 9.31806 9.91406 9.6519 9.91406 10C9.91406 10.3481 9.7585 10.6819 9.48159 10.9281C9.20468 11.1742 8.82911 11.3125 8.4375 11.3125C8.04589 11.3125 7.67032 11.1742 7.39341 10.9281C7.1165 10.6819 6.96094 10.3481 6.96094 10C6.96094 9.6519 7.1165 9.31806 7.39341 9.07192C7.67032 8.82578 8.04589 8.6875 8.4375 8.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconography);
export default __webpack_public_path__ + "static/media/Iconography.1a34b7b1ba83be81fb7552a881b3f03b.svg";
export { ForwardRef as ReactComponent };